const PAGE_SIZE_OPTIONS = [12, 25, 50, 100, 200]

export default function ExchangeRatePaginationControls({
  page = 1,
  pageSize = 50,
  total = 0,
  totalPages = 1,
  onPageChange,
  onPageSizeChange,
  itemLabel = 'rows',
}) {
  const currentPage = Math.max(1, Number(page || 1))
  const pages = Math.max(1, Number(totalPages || Math.ceil(Number(total || 0) / Number(pageSize || 1)) || 1))
  const start = total > 0 ? ((currentPage - 1) * Number(pageSize || 1)) + 1 : 0
  const end = Math.min(Number(total || 0), currentPage * Number(pageSize || 1))

  return (
    <div className="flex flex-col gap-3 border-t border-outline bg-surface px-3 py-3 text-sm sm:flex-row sm:items-center sm:justify-between">
      <div className="text-muted-foreground">
        {start}-{end} of {Number(total || 0)} {itemLabel}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <label className="flex items-center gap-2">
          <span className="text-muted-foreground">Page size</span>
          <select
            value={Number(pageSize || 50)}
            onChange={(event) => onPageSizeChange(Number(event.target.value))}
            className="rounded-md border border-outline bg-background px-2 py-1"
          >
            {PAGE_SIZE_OPTIONS.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </label>
        <button
          type="button"
          className="rounded-md border border-outline px-3 py-1 disabled:opacity-50"
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          Previous
        </button>
        <span className="min-w-[5rem] text-center text-muted-foreground">
          {currentPage} / {pages}
        </span>
        <button
          type="button"
          className="rounded-md border border-outline px-3 py-1 disabled:opacity-50"
          disabled={currentPage >= pages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  )
}
